import React, { Component } from 'react';
import { Container, Col, Input } from 'reactstrap';
import { RowItem } from '../layout/RowItem';
import AdminFunctions from './AdminFunctions';
import { _fetch } from '../_fetch';
import { Spinner } from 'reactstrap';
import '../layout/site.css';

export class SiteSettings extends Component {
    static displayName = SiteSettings.name;

    constructor(props) {
        super(props);

        this.state = {
            Id: null,
            ClientNumber: null,
            loading: false
        };
    }

    async componentDidMount() {
        const isAdmin = AdminFunctions.isAdminAsync();
        if (!isAdmin) {
            this.props.history.push('/accessdenied');
        }

        this.loadPage();
    }

    loadPage() {
        try {
            this.setState({ loading: true });
            var fetch = _fetch();
            fetch.get("api/admin/GetSiteSettings")
                .then((data) => {
                    JSON.stringify(data)
                    this.setState({
                        Id: data.id,
                        ClientNumber: data.clientNumber,
                        loading: false
                    })
                });
        }
        catch (err) {
            this.setState({ loading: false });
            console.log('loadPage - ' + err);
        }
    }

    saveSettings() {
        try {
            this.setState({ loading: true });

            var fetch = _fetch();
            fetch.post("api/admin/SaveSiteSettings", {
                Id: this.state.Id,
                ClientNumber: isNaN(this.state.ClientNumber) ? 0 : parseInt(this.state.ClientNumber)
            })
                .then((data) => {
                    this.setState({ loading: false });
                });
        }
        catch (err) {
            this.setState({ loading: false });
            console.log('saveSettings - ' + err);
        }
    }

    render() {
        return (
            <div>
                {this.state.loading === true ?
                    <div>
                        <Spinner color="#000" children='' style={{ position: 'fixed', top: '50%', left: '50%' }} />
                    </div>
                    : null
                }
                <Container className='container-main'>
                    <RowItem>
                        <Col>
                            <h3>Site Settings</h3>
                        </Col>
                    </RowItem>
                    <div className='site-settings-row'>
                        <label>Credit applications with a client number less than or equal to this value cannot be edited:</label>
                        <Input
                            type='numeric'
                            onChange={(e) => {
                                this.setState({ ClientNumber: e.target.value });
                            }}
                            name='clientid'
                            maxLength={4}
                            placeholder={''}
                            value={this.state.ClientNumber}
                            style={{ padding: '3px', width: '50px' }}
                            autoFocus
                        />
                    </div>
                    <div className='site-settings-row'>
                        <button
                            className="creditAppNext"
                            style={{ whiteSpace: 'nowrap' }}
                            disabled={this.state.loading ? true : false}
                            onClick={() => {
                                this.saveSettings();
                            }}>
                            Save Settings
                        </button>
                    </div>
                </Container>
            </div>
        )
    }
}